import { createContext, useContext, useState, useEffect } from 'react';
import { dealerLogin as apiLogin, dealerGetMe } from '../services/api';

const DealerAuthContext = createContext(null);

export function DealerAuthProvider({ children }) {
  const [dealer, setDealer] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('witt_dealer_token');
    if (stored) {
      dealerGetMe(stored)
        .then(d => { setDealer(d); setToken(stored); })
        .catch(() => { localStorage.removeItem('witt_dealer_token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    setToken(res.token);
    setDealer(res.dealer);
    localStorage.setItem('witt_dealer_token', res.token);
    return res;
  };

  const logout = () => {
    setToken(null);
    setDealer(null);
    localStorage.removeItem('witt_dealer_token');
  };

  const refreshDealer = async () => {
    if (!token) return;
    const d = await dealerGetMe(token);
    setDealer(d);
    return d;
  };

  return (
    <DealerAuthContext.Provider value={{ dealer, token, loading, login, logout, refreshDealer, isAuthenticated: !!dealer }}>
      {children}
    </DealerAuthContext.Provider>
  );
}

export function useDealerAuth() {
  const ctx = useContext(DealerAuthContext);
  if (!ctx) throw new Error('useDealerAuth must be used within DealerAuthProvider');
  return ctx;
}
